import { createRoute } from '@tanstack/react-router';
import { rootRoute } from './__root';
import { LicensesPage } from '@/pages/LicensesPage';

export const licensesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/licenses',
  component: LicensesPage,
});
